// Suitability Form Initial State
export const suitabilityInitialState = {
  signatures: {
    client_sig: null,
    client_text: '',
    second_sig: null,
    second_text: '',
  },
}
